export const GetUserSelf = {
    endpoint: "/users/@self",
    pathParams: [],
    method: "GET",
    request: undefined,
    response: undefined,
    paginated: false
};
//# sourceMappingURL=GetUserSelf.js.map